import { ResponsiveLine } from "@nivo/line";
import { useSelector } from "react-redux";
import { Card, Col, Row, Spin, Typography } from 'antd';
import { useGetSubscriptionStatsQuery } from "../slices/subscriptionApiSlice";
import PieChart from "./Usercomp/pieChart";
import { useGetDailySalesQuery } from "../slices/paymentApiSlice";
import { height } from "@mui/system";
import { useMediaQuery } from '@mui/material';
const { Title, Text } = Typography;

const TotalSaleScreen = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

  const { darkmode } = useSelector((state) => state.darkmode);

  const { data: subscriptionData, isLoading: subscriptionLoading, error: subscriptionError } = useGetSubscriptionStatsQuery();
  const { data: getDailySales, isLoading: salesLoading, error: salesError } = useGetDailySalesQuery();
  console.log("sales..",getDailySales);
  

  const saleData = getDailySales?.[0]?.data
    ?.filter(item => item?.x && item?.y !== undefined)
    ?.map(item => ({ x: item.x, y: item.y / 100 }));


  if (subscriptionLoading || salesLoading) return <Spin />;
  if (subscriptionError || salesError) return <p>Error loading data</p>;

  return (
    <Row gutter={[16, 24]}>
      <Col md={12} xs={24}>
        <Card title="Total Sales" bordered={false} className='card_hover' style={{height:"400px"}}>
         <div style={{ height: isMobile ? 300 : 315, width: '100%' }}>
            <ResponsiveLine
              data={[{ id: "Sales", data: saleData || [] }]}
              margin={{ top: 50, right: isMobile ? 20 : 110, bottom: 50, left: isMobile ? 45 : 60 }}              yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true }}
              axisBottom={{ legend: 'Date', legendOffset: 36 }}
              axisLeft={{ legend: 'Sales', legendOffset: -55 }}
              colors={['#d09d4c']}
              pointSize={10}
              useMesh={true}
            legends={
          isMobile
            ? [] // No legend on mobile to avoid clutter
            :
            [{
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 100,
                itemWidth: 80,
                itemHeight: 22,
                symbolShape: 'circle'
              }]}

                theme={{
        textColor: '#7e7e78',
        axis: {
          ticks: {
            text: {
              fill: '#7e7e78'
            }
          },
          legend: {
            text: {
              fill: '#7e7e78'
            }
          }
        },
        legends: {
          text: {
            fill: '#7e7e78'
          }
        },
        tooltip: {
          container: {
            color: '#000'
          }
        }
      }}
            />
          </div>
        </Card>
      </Col>

      <Col md={12} xs={24}>
        <Card title="Total Subscription" bordered={false} className="card_hover"   style={{height:"400px"}}>
          {subscriptionData?.plans ? (
            <PieChart plans={subscriptionData.plans} sx={{ height: "300px" }} />
          ) : (
            <p>Loading pie chart...</p>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default TotalSaleScreen;
